export default function Help({ onClose }: { onClose: () => void }) {
  return (
    <div className="modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label="Keyboard & help">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>How it works</h2>
        <p className="lead">
          You'll hear each question spoken aloud — never shown — then answer out loud, just like the real interview.
          The room dims while you speak. When the drill ends, you'll see your pace, fillers, and how quickly you
          started, with every answer replayable in your own words.
        </p>
        <div className="field">
          <label>Keyboard</label>
          <ul className="kbd-list">
            <li><kbd>Space</kbd> Start / stop your answer</li>
            <li><kbd>N</kbd> Next question</li>
            <li><kbd>R</kbd> Repeat the question (once)</li>
            <li><kbd>Esc</kbd> Pause &amp; leave the session</li>
          </ul>
        </div>
        <p className="egress-note">
          No accounts, no sign-up. Everything stays in this browser; only the voice and transcription calls leave the
          device, through your own keys.
        </p>
        <div className="rv-foot">
          <button className="btn-primary" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  );
}
